import { render, staticRenderFns } from "./upline-downline-form.vue?vue&type=template&id=6c70d972&"
import script from "./upline-downline-form.vue?vue&type=script&lang=js&"
export * from "./upline-downline-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports